import { useQContent } from '@exam-management/common/qcontent-provider';
import { QuestionGroupType } from '@exam-management/graphql';
import { useQBankStructure } from '@exam-management/qbs-provider';
import { Flex, ReadonlyField, Text, Tooltip, InfoOutlinedIcon } from '@shared/components';
import { useMemo } from 'react';

import { LocationFields } from '../../components';

export default function LocationView() {
  const { qBankStructureLevelItems, qBankStructureLevels } = useQBankStructure();
  const { qContent } = useQContent();

  const qBankStructureLevelWithoutFirstLevel = useMemo(
    () => qBankStructureLevels.filter((qBankStructureLevel) => qBankStructureLevel.level !== 1),
    [qBankStructureLevels],
  );

  const levelItems = useMemo(
    () =>
      qBankStructureLevelItems.filter((qbsLevelItem) =>
        qContent.questionStructures?.find((questionStructure) => {
          return qbsLevelItem.id === questionStructure.refLevelItemId;
        }),
      ),
    [qBankStructureLevels, qBankStructureLevelItems],
  );

  const isLOQ = qContent.questionGroup?.type === QuestionGroupType.LotOfQuestion;

  return (
    <>
      <LocationFields qbsLevels={qBankStructureLevelWithoutFirstLevel} qbsLevelItems={levelItems} />
      {isLOQ ? (
        <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(1) }}>
          <Flex sx={{ gap: (theme) => theme.spacing(1) }}>
            <Text variant='body2Semibold'>LOQ</Text>
            <Tooltip title='ชุดของข้อสอบที่มีความคล้ายคลึงกันมาก'>
              <InfoOutlinedIcon
                sx={{ fontSize: '20px', color: (theme) => theme.palette.text.secondary }}
              />
            </Tooltip>
          </Flex>
          <ReadonlyField content={qContent.questionGroup?.name ?? ''} />
        </Flex>
      ) : null}
    </>
  );
}
